import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './GalleryImageItem.css';
import { IConstructionProgressImage } from '../../types/constructionProgress';
import { Image } from '@cian/ui-kit';

import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';

export interface IGalleryImageItemProps {
  image: IConstructionProgressImage;
  dateIndex: number;
  index: number;
  overlay?: boolean;
  onClick(slideIndex: number, dateSlideIndex: number): void;
}

export const GalleryImageItem: React.FC<IGalleryImageItemProps> = ({ image, dateIndex, index, onClick, overlay }) => (
  <div
    onClick={() => onClick(index, dateIndex)}
    data-testid="GalleryImageItem"
    className={clsx(styles['container'], overlay && styles['with-overlay'])}
  >
    <Image src={image.fullUrl} title={image.text} objectFit={'cover'} />
    {overlay && (
      <div className={styles['overlay']}>
        <span className={styles['overlay-text']}>Посмотреть еще</span>
        <IconActionChevronRight12 color={'icon-inverted-default'} />
      </div>
    )}
  </div>
);
